export class ComparateurCritère {
    code;
    nom;
    abréviation = "";

    constructor(code, nom, abréviation, négation) {
        this.code = code;
        this.nom = nom;
        this.abréviation = abréviation || "";
        this.négation = négation || false;
    }
}

// ≉ ≈
export const Comparateurs = Object.freeze({
    ÉGALE: new ComparateurCritère("ÉGALE", "est égale à","="),
    COMMENCE_PAR: new ComparateurCritère("COMMENCE_PAR", "commence par","="),
    SE_TERMINE_PAR: new ComparateurCritère("SE_TERMINE_PAR", "se termine par", "="),
    CONTIENT: new ComparateurCritère("CONTIENT", "contient", "="),
    EST_PARMI: new ComparateurCritère("EST_PARMI", "est parmi", "∈"),
    EST_DIFFÉRENT: new ComparateurCritère("EST_DIFFÉRENT", "est différent de", "≠", true),
    NE_COMMENCE_PAS_PAR: new ComparateurCritère("NE_COMMENCE_PAS_PAR", "ne commence pas par","≠",true),
    NE_SE_TERMINE_PAS_PAR: new ComparateurCritère("NE_SE_TERMINE_PAS_PAR", "ne se termine pas par","≠", true),
    NE_CONTIENT_PAS: new ComparateurCritère("NE_CONTIENT_PAS", "ne contient pas", "≠", true),
    N_EST_PAS_PARMI: new ComparateurCritère("N_EST_PAS_PARMI", "n'est pas parmi", "∉", true),
});
